export const stepIds = {
  initial: 'initial',
  afterSaleParentProductSelector: 'afterSaleParentProductSelector',
  obdError: 'obdError',
  obdResidenceError: 'obdResidenceError',
  personalData: 'personalData',
  productOfferingToBuyChanged: 'productOfferingToBuyChanged',
  personalDataInitial: 'personalDataInitial',
  personalDataStepWithoutInitCQ: 'personalDataStepWithoutInitCQ',
  installation: 'installation',
  newInstallationAddress: 'newInstallationAddress',
  permanentResidence: 'permanentResidence',
  selectParentProduct: 'selectParentProduct',
  mainAction: 'mainAction',
  mobileSecondaryAction: 'mobileSecondaryAction',
  landLineSecondaryAction: 'landLineSecondaryAction',
  alreadyOwnedProductsChoices: 'alreadyOwnedProductsChoices',
  portabilityOTP: 'portabilityOTP',
  ppip: 'ppip',
  commitment: 'commitment',
  deviceInstallation: 'deviceInstallation',
  shipment: 'shipment',
  payment: 'payment',
  risk: 'riesgo',
  scoring: 'scoring',
  summary: 'summary',
  manualSummary: 'manualSummary',
  manualRenewalSummary: 'manualRenewalSummary',
  manualNewClientSummary: 'manualNewClientSummary',
  manualNewClientSummaryContinue: 'manualNewClientSummaryContinue',
  packSummary: 'packSummary',
  oneClickSummary: 'oneClickSummary',
  deviceSummary: 'deviceSummary',
  vtlSummary: 'vtlSummary',
  vtlNewClientSummary: 'vtlNewClientSummary',
  vtlNewClientSummaryContinue: 'vtlNewClientSummaryContinue',
  vtlFunded: 'vtlFunded',
  vtlCardPayment: 'vtlCardPayment',
  duoNewClientSummary: 'duoNewClientSummary',
  duoNewClientSummaryContinue: 'duoNewClientSummaryContinue',
  chooseNumberOTP: 'chooseNumberOTP',
  signature: 'signature',
  genericSignature: 'genericSignature',
  confirmation: 'confirmation',
  creditLimitError: 'creditLimit',
  riskError: 'fraud',
  debtError: 'debt',
  numberOfSims: 'numberOfSims',
};

export const stepTaggingNames = {
  initial: 'inicial',
  afterSaleParentProductSelector: 'seleccionar-producto-padre-post-venta',
  obdError: 'error-obd',
  obdResidenceError: 'error-obd-residencia',
  personalData: 'datos-personales',
  personalDataStepWithoutInitCQ: 'datos-personales',
  productOfferingToBuyChanged: 'producto-modificado',
  permanentResidence: 'domicilio-facturacion',
  installation: 'instalacion',
  newInstallationAddress: 'nueva-direccion-instalacion',
  selectParentProduct: 'seleccionar-producto-padre',
  mainAction: 'accion-principal',
  mobileSecondaryAction: 'accion-secudaria-movil',
  landLineSecondaryAction: 'accion-secudaria-fijo',
  alreadyOwnedProductsChoices: 'eleccion-necesaria',
  portabilityOTP: 'otp-portabilidad',
  commitment: 'plazos',
  ppip: 'linea-provisional',
  deviceInstallation: 'instalacion-dispositivo',
  shipment: 'envio',
  payment: 'forma-pago',
  risk: 'riesgo',
  scoring: 'datos-financieros',
  summary: 'resumen',
  confirmation: 'confirmacion',
  funded: 'pago-financiado',
  card: 'pago-tarjeta',
  chooseNumberOTP: 'elegir-otp',
  signature: 'firma',
  creditLimitError: 'limite-credito',
  riskError: 'riesgo',
  debtError: 'deuda',
  numberOfSims: 'numero-de-sims',
};

/* stepTaggingNames para otras pantallas:
  LAND_LINE_CHOOSE_ADDRESS: 'linea-fija-eleccion-direccion',
  LAND_LINE_INTRODUCE_ADDRESS: 'linea-fija-introducir-direccion',
  LAND_LINE_CHOOSE_NUMBER: 'linea-fija-eleccion-numero',
  MOBILE_LINE_CHOOSE_NUMBER: 'linea-movil-eleccion-numero',
  EXTRA_MOBILE_LINE_CHOOSE_NUMBER: 'linea-movil-extra-eleccion-numero',
  INSTALLATION: 'eleccion-instalacion',
  PPIP: 'ppip',
  ACCOUNT_RISK: 'cuenta-riesgo',
  CHOOSE_SHIPPING: 'eleccion-envio',
  CHOOSE_DECODER: 'eleccion-desco',

  */
